var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDepartementLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0616 7.97364L12.0615 5.24272C12.0612 4.59066 12.061 4.26463 11.9025 3.99127C11.744 3.71791 11.4611 3.55828 10.8952 3.23901L8.00893 1.6105C7.46317 1.30256 7.19029 1.14859 6.89237 1.14859C6.59446 1.14859 6.32158 1.30256 5.77582 1.6105L2.88955 3.23901C2.32371 3.55828 2.04078 3.71791 1.88224 3.99127C1.7237 4.26463 1.72354 4.59066 1.72322 5.24272L1.72314 7.97364C1.72314 10.1714 1.72314 11.2703 2.39605 11.953C3.06895 12.6358 4.15197 12.6358 6.31802 12.6358H7.46673C9.63276 12.6358 10.7158 12.6358 11.3887 11.953C12.0616 11.2703 12.0616 10.1714 12.0616 7.97364Z",
    stroke: "#006838",
    strokeWidth: 0.861538,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.74355 7.46675H4.59483M9.1897 7.46675H8.04099M5.74355 5.16931H4.59483M5.74355 9.76418H4.59483M9.1897 5.16931H8.04099M9.1897 9.76418H8.04099",
    stroke: "#006838",
    strokeWidth: 0.861538,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepartementLink);
export default __webpack_public_path__ + "static/media/DepartementLink.eca8e89f080b62ea9488513b908143d1.svg";
export { ForwardRef as ReactComponent };